// Mock data for HEARD - direct-to-consumer music app
// This data is used to render the frontend before backend integration.

export const SAMPLE_AUDIO = [
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3",
];

export const artistMock = {
  id: "meek-mill",
  name: "MEEK MILL",
  verified: true,
  genre: "HIP-HOP",
  monthlyListeners: "12.4M",
  heroImage:
    "https://images.pexels.com/photos/4722576/pexels-photo-4722576.jpeg",
  avatar:
    "https://images.unsplash.com/photo-1659708701940-e60893ef03d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  bio: "Independent. Unfiltered. Direct to you. Every stream, every drop \u2014 owned by the artist.",
  songs: [
    {
      id: "s1",
      title: "Dreams and Nightmares",
      label: "SINGLE",
      price: 1.99,
      plays: "4.2M",
      cover:
        "https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
      audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    },
    {
      id: "s2",
      title: "Going Bad",
      label: "SINGLE",
      price: 1.99,
      plays: "6.8M",
      cover:
        "https://images.unsplash.com/photo-1641494684667-b8c56b03a764?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
      audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
    },
    {
      id: "s3",
      title: "How Far We Go",
      label: "SINGLE",
      price: 1.99,
      plays: "2.1M",
      cover:
        "https://images.unsplash.com/photo-1642444525640-d3eb287ed389?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
      audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
    },
    {
      id: "s4",
      title: "Respect The Game",
      label: "SINGLE",
      price: 1.99,
      plays: "1.5M",
      cover:
        "https://images.pexels.com/photos/15578335/pexels-photo-15578335.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
    },
    {
      id: "s5",
      title: "All Eyes On You",
      label: "SINGLE",
      price: 1.99,
      plays: "3.3M",
      cover:
        "https://images.unsplash.com/photo-1487452066049-a710f7296400?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
      audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3",
    },
    {
      id: "s6",
      title: "Blue Notes",
      label: "SINGLE",
      price: 1.99,
      plays: "980K",
      cover:
        "https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=600&sat=-50",
      audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3",
    },
  ],
  videos: [
    {
      id: "v1",
      title: "Behind The Sound",
      thumbnail:
        "https://images.unsplash.com/photo-1603126004372-e63e3b53934b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      youtubeId: "fzQ6gRAEoy0",
    },
    {
      id: "v2",
      title: "On The Road",
      thumbnail:
        "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      youtubeId: "Tdsbn4Vd7CY",
    },
    {
      id: "v3",
      title: "Night Sessions",
      thumbnail:
        "https://images.unsplash.com/photo-1542902093-d55926049754?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      youtubeId: "Pke7zlfHOO4",
    },
    {
      id: "v4",
      title: "City Lights",
      thumbnail:
        "https://images.unsplash.com/photo-1495430288918-03be19c7c485?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      youtubeId: "9j4Vp7TjVDc",
    },
  ],
  membership: {
    title: "EXCLUSIVE MEMBERSHIP",
    price: 4.99,
    description:
      "Get exclusive access to behind the scenes content, early drops and more.",
    perks: [
      "Early access to new drops",
      "Behind the scenes content",
      "Members-only live sessions",
      "Discounts on merch",
    ],
  },
};
